import { SettingsCustomFormFieldData } from '../../../models/settings/settings-custom-form-field-data.class';
import { FieldDataInterface } from '../../../models/settings/settings-custom-form-field-data.model';

export class SettingsRichTextV1Field extends SettingsCustomFormFieldData {

    // constructor(type:string, field?:FieldDataInterface) {
    //   super(type, field);
    // }

    public serialize(): FieldDataInterface {
        return this._serialize({});
    }

    public deserialize(field: FieldDataInterface): SettingsRichTextV1Field {
        const self = new SettingsRichTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
        return self;
    }


    public update(updateData: Partial<SettingsRichTextV1Field>) : SettingsRichTextV1Field {
        // Create a new instance with the initial data
        const self = new SettingsRichTextV1Field(
            this.type,
            this.position,
            this.id,
            this.label,
            this.mandatory,
            this.active,
        );

        // Apply any updates provided in updateData
        if (updateData) {
            Object.assign(self, updateData);
            // mark the field as changed    
            self.changed = true;
        }
        
        return self;
        
    }

}
